import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('ui-attributes.condition.comparator.type.geoPoint.Constants');
export default {
  DISTANCE_OPTS: [{
    get name() {
      return t('kilometers');
    },
    value: 'km'
  }, {
    get name() {
      return t('miles');
    },
    value: 'mi'
  }, {
    get name() {
      return t('yards');
    },
    value: 'yd'
  }, {
    get name() {
      return t('feet');
    },
    value: 'ft'
  }, {
    get name() {
      return t('inches');
    },
    value: 'in'
  }, {
    get name() {
      return t('centimeters');
    },
    value: 'cm'
  }, {
    get name() {
      return t('millimeters');
    },
    value: 'mm'
  }, {
    get name() {
      return t('nauticalMiles');
    },
    value: 'NM'
  }]
};